import React, { useState } from "react";
import loginBg from "../../assets/images/login-bg.svg";
import { forgotPassword, ForgotPasswordRequest } from "../../service/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const requestData: ForgotPasswordRequest = {
        email: email.trim(),
        tenant_name: tenantName.trim().toLowerCase(),
      };

      const response = await forgotPassword(requestData);
      if (response.data.success) {
        setIsSubmitted(true);
      } else {
        setError(response.data.resMessage || "Failed to send reset link");
      }
    } catch (error: any) {
      console.error("Error sending reset link:", error);
      setError(
        error.response?.data?.resMessage ||
          error.response?.data?.message ||
          "An error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid p-0 h-100">
      <div className="row no-gutter h-100 full-height">
        <div
          className="col-sm-7 d-none d-lg-flex bg"
          style={{ backgroundImage: "url('" + loginBg + "')" }}
        ></div>
        <div className="col-lg-5 bg-white">
          <div className="loginCont">
            <div className="row no-gutters h-100 align-items-center">
              <div className="col-sm-12 mx-auto">
                <div className="login-form">
                  <h2 className="mb-4">Forgot Password</h2>

                  {error && <div className="alert alert-danger">{error}</div>}

                  {!isSubmitted ? (
                    <form onSubmit={handleSubmit}>
                      <div className="form-group mb-3">
                        <label htmlFor="tenantName" className="form-label">
                          Tenant Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="tenantName"
                          placeholder="Enter your tenant name"
                          value={tenantName}
                          onChange={(e) => setTenantName(e.target.value)}
                          required
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label htmlFor="email" className="form-label">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Enter your email address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        <div className="form-text">
                          We'll send you a reset link to this email. The link
                          will expire in 20 minutes.
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100 mb-3"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Sending...
                          </>
                        ) : (
                          "Send Reset Link"
                        )}
                      </button>

                      <div className="text-center">
                        <a href="/login" className="text-decoration-none">
                          Back to Login
                        </a>
                      </div>
                    </form>
                  ) : (
                    <div className="alert alert-success">
                      <h5>Check Your Email!</h5>
                      <p className="mb-3">
                        We've sent a password reset link to{" "}
                        <strong>{email}</strong>. The link will expire in 20
                        minutes for security reasons.
                      </p>
                      <div className="text-center">
                        <a href="/login" className="btn btn-primary">
                          Back to Login
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
